// Monday retires API versions on a rolling schedule and, per their versioning docs, serves the
// *maintenance* version for any request naming a retired one rather than erroring. 2025-10 is
// retired, so this pin no longer selects the schema these queries were written against —
// requests are answered by whatever Monday currently maintains. Fields removed since then fail
// at runtime with the constant message "Graphql validation errors" (this is how photo_thumb
// broke four features at once in August 2026).
//
// Bump this deliberately and re-audit every query in monday-queries.ts when you do — see the
// 2026-07 migration ticket.
export const MONDAY_API_VERSION = "2025-10";
